<template>
  <div class="vacancy-edit-characteristics__section-content">
    <div class="vacancy-edit-characteristics__sub-section">
      <button v-if="!isShowCommentComputed"
              @click.prevent="onAddComment"
              class="base-btn  base-btn--outline-grey base-btn--small">
        <BaseSvg name="ico-comment"
                 width="1.3rem"
                 height="1.4rem"
                 style="position: relative; top: 0.1rem"/>
        <span>{{$tNewVacancy('Add a comment')}}</span>
      </button>
      <TranslateFiled v-else
                      :value="inputs.comment.value"
                      :label="$tNewVacancy('Comment')"
                      editor
                      withFullDelete
                      @input="onInput('comment', $event)"
                      @delete="onDeleteComment('comment')"/>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import TranslateFiled from './TranslateFiled'

  export default {
    components: {
      TranslateFiled
    },
    data() {
      return {
        isShowComment: false,
      }
    },
    computed: {
      ...mapState('vacancyEdit/characteristicsAdditional/', [
        'muted',
        'inputs'
      ]),
      isShowCommentComputed() {
        return this.isShowComment || this.inputs.comment.value
      },
    },
    methods: {
      onAddComment() {
        this.isShowComment = true
      },
      onDeleteComment(key) {
        this.isShowComment = false
        this.onInput(key, null)
      },
      onInput(key, value) {
        this.$store.commit('vacancyEdit/characteristicsAdditional/setInputValue', {key, value})
      }
    }
  }
</script>

<style lang="less">

</style>
